export default __webpack_public_path__ + "static/media/0069.90899e51.png";